import { memoize } from 'lodash';
import { createSelector } from 'reselect';
import { FormControlErrors, FormErrors, FormState } from 'ia-react-core/~/interfaces/FormState';

import get from '../../utils/accessors/get';

const validSelector = () => createSelector(
  (formState: FormState) => get(formState, 'errors'),
  (errors: FormErrors) => getValidMap(errors),
);

function getValidMap(errors: FormErrors | FormControlErrors, nested = false) {
  const keys = Object.keys(errors);

  if (!keys.length && nested) {
    return true;
  }

  return keys.reduce((result, key) => {
    const keyValue = errors[key];
    if (typeof keyValue === 'object') {
      Object.defineProperty(result, key, {
        enumerable: true,
        get: memoize(() => getValidMap(keyValue, true)),
      });
    } else {
      return Boolean(result && !keyValue);
    }

    return result;
  }, {});
}

/**
 * @component
 * @visibleName validSelector
 */
export default validSelector;
